<!-- 常读快应用订单 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div v-if="role_control.includes(1)" class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			<div v-else class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" 
				:disabledDate="DateControl"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">快应用名称</div>
				<a-input v-model="r_qk_name" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">用户Device_id</div>
				<a-input v-model="r_device_id" allowClear placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">染色时间</div>
				<a-range-picker
					:locale="locale" 
				    :show-time="{ format: 'HH:mm:ss' }"
				    format="YYYY-MM-DD HH:mm:ss"
				    :placeholder="['开始时间', '结束时间']" 
				    @change="onChangeDateC"
				    @ok="onDateC_ok" 
				/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_push_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">订单金额</div>
				<div style="display: flex;align-items: center;">
					<a-input-number v-model="r_start_money" id="inputNumber" style="width:110px;" @change="onChangeNumberS" />
					<div style="margin: 0 10px;">至</div>
					<a-input-number v-model="r_end_money" id="inputNumber1" style="width:110px;" @change="onChangeNumberE" />
				</div>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">订单ID</div>
				<a-input v-model="r_order_trade_no" allowClear placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否首充</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeG" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>

			<div class="screen-box">
				<div class="screen-label">是否为注册当天订单</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否加桌</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeI" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配到计划</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeF" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeTGPT"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in tgptSelect" :key="key" :value="key">{{value}}</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">计划ID</div>
				<a-input v-model="r_plan_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0项目ID</div>
				<a-input v-model="r_marketing_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0广告ID</div>
				<a-input v-model="r_marketing_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button>
			<a-button @click="custtom_visible = true" class="screen-box" icon="unordered-list" >自定义列</a-button>
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default',}" 
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type != 'is_repay_order' && z_tem.type != 'is_reg_day_order' && z_tem.type != 'add_desktop_time' && z_tem.type != 'match_type' && z_tem.type != 'cz'" 
				class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 是否首充 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'is_repay_order'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.is_repay_order == 1 ? '否':'是'}}
				</div>
				<!-- 注册当天订单 -->
				<div  v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'is_reg_day_order'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.is_reg_day_order == 0? '否':'是'}}
				</div>
				<!-- 是否加桌 -->
				<div  v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'add_desktop_time'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.add_desktop_time? '是':'否'}}
				</div>
				
				<!-- 匹配指标 -->
				<div  v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'match_type'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.match_type}}
				</div>
				
				<!-- 操作 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'cz'" class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<template v-if="item.is_report_pay != '已回传' && item.is_report_pay != '待处理'">
						<div v-if="item.marketing_click_id > 0 || item.clickid" @click="HcTdTable(item,0)" 
						style="color: #62a8ea;cursor: pointer;">手动回传</div>
						
						<div v-else-if="item.marketing_click_id == 0 && !item.clickid" @click="HcTdTable(item,1)" 
						style="color: #62a8ea;cursor: pointer;">自定义回传</div>
					</template>
				</div>
			</template>
		</div>
		
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': body_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading" :width='700'>
		<div class="form-cell-box" >
			<div class="class-title">推广平台</div>
			
			<a-radio-group name="radioGroup" :value="h_report_id_type" @change="handleChangeH">
			    
				<a-radio v-for="(value,key) in tgptSelect" :key="key" :value="key">{{value}}</a-radio>
				<!-- <a-radio :value="1">oppo</a-radio>
			    <a-radio :value="2">vivo</a-radio>
				<a-radio :value="3">巨量</a-radio>
			    <a-radio :value="4">华为</a-radio>
				<a-radio :value="5">腾讯</a-radio>
				<a-radio :value="6">百度</a-radio>
				<a-radio :value="7">快手</a-radio> -->
			</a-radio-group>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">推广平台点击表</div>
			<div @click="goLPzj" style="cursor: pointer;">前往对应点击表，寻找点击id</div>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">点击表ID</div>
	    	<a-input v-model="h_report_id" placeholder="请输入点击表ID" style="width: 290px;"  />
	    </div>
	</a-modal>
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="customTd" @cancel="customTd" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:10px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { CdOrderReport, CdOrderCustomReport, CdOrderList, CdOrderExport, qkChannelMedia } from '@/request/api'
export default {
	name: 'orderCD_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", sort_status:0, sort_control: false, show_control: true, }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"快应用名称", width:100, type:"qk_name", sort_status:0, sort_control: false, show_control: true, },
				
				{title:"订单ID", width:180, type:"out_trade_no", sort_status:0, sort_control: false, show_control: true, },
				{title:"用户DeviceId", width:180, type:"device_id", sort_status:0, sort_control: false, show_control: true, },
				{title:"染色时间", width:150, type:"register_date", sort_status:0, sort_control: true, show_control: true, },
				{title:"注册IP", width:130, type:"user_ip", sort_status:0, sort_control: false, show_control: true, },
				{title:"推广链接ID", width:150, type:"promotion_id", sort_status:0, sort_control: false, show_control: true, },
				
				{title:"订单金额(元)", width:120, type:"pay_fee", sort_status:0, sort_control: false, show_control: true, },
				{title:"订单时间", width:150, type:"pay_date", sort_status:0, sort_control: true, show_control: true, },
				{title:"支付方式", width:100, type:"pay_way", sort_status:0, sort_control: false, show_control: true, },
				{title:"书本ID", width:170, type:"book_id", sort_status:0, sort_control: false, show_control: true, },
				{title:"活动充值", width:90, type:"is_activity", sort_status:0, sort_control: false, show_control: true, },
				
				{title:"是否首充", width:90, type:"is_repay_order", sort_status:0, sort_control: false, show_control: true, },
				{title:"注册当天订单", width:110, type:"is_reg_day_order", sort_status:0, sort_control: false, show_control: true, },
				{title:"订单间隔天数", width:110, type:"t_days_order", sort_status:0, sort_control: false, show_control: true, },
				{title:"是否加桌", width:110, type:"add_desktop_time", sort_status:0, sort_control: false, show_control: true, },
				// {title:"匹配结果来源", width:130, type:"is_match_self", sort_status:0, sort_control: false, show_control: true, },
				
				// {title:"是否匹配", width:130, type:"match_self_click", sort_status:0, sort_control: false, show_control: true, },
				{title:"推广平台", width:120, type:"channel_name", sort_status:0, sort_control: false, show_control: true, },
				{title:"匹配点击表ID", width:130, type:"match_user_id", sort_status:0, sort_control: false, show_control: true, },
				{title:"计划ID", width:160, type:"adid", sort_status:0, sort_control: false, show_control: true, },
				{title:"创意ID", width:160, type:"creativeid", sort_status:0, sort_control: false, show_control: true, },
				{title:"巨量2.0项目ID", width:170, type:"marketing_project_id", sort_status:0, sort_control: false, show_control: true, },
				{title:"巨量2.0广告ID", width:170, type:"marketing_promotion_id", sort_status:0, sort_control: false, show_control: true, },
				
				{title:"匹配指标", width:100, type:"match_type", sort_status:0, sort_control: false, show_control: true, },
				{title:"是否回传", width:100, type:"is_report_pay", sort_status:0, sort_control: false, show_control: true, },
				{title:"正式投放回传原因：付费1", width:190, type:"report_pay_reason", sort_status:0, sort_control: false, show_control: true, },
				{title:"回传时间", width:190, type:"report_pay_time", sort_status:0, sort_control: false, show_control: true, },
				{title:"操作", width:160, type:"cz", sort_status:0, sort_control: false, show_control: true, },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			sticky_index: 1,
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_qk_name: null, // 快应用名称
			r_order_trade_no: "", // 订单ID
			r_device_id: "", // 用户Device_id
			r_plan_id: "", // 计划ID
			r_push_link_id: "", // 推广链接ID
			
			r_is_report_pay: undefined, // 是否回传 0为否。1为是
			r_is_reg_day_order: undefined, // 是否为注册当天订单 0为否。1为是
			r_is_match_ad: undefined, // 是否匹配到计划 0为否。1为是
			r_is_first_pay: undefined, // 是否首充 0为否。1为是
			r_is_add_desktop: undefined, // 是否加桌 0为否。1为是
			r_marketing_project_id: null, // 项目ID
			r_marketing_promotion_id: null, // 广告ID
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			role_control: [], // 用户权限控制
			
			regStartDate: "", // 开始注册时间
			regEndDate: "", // 结束注册时间
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			r_start_money: null, // 开始-金额区间
			r_end_money: null, // 结束-金额区间
			
			r_channel_id: undefined, // 推广平台
			
			custtom_visible: false, // 自定义列
			customCheckboxData: [ // 自定义列
				{
					label: "表格项：",
					showTitle:['out_trade_no','device_id','register_date','user_ip','pay_fee','pay_date','pay_way','promotion_id','book_id','is_activity','is_repay_order','is_reg_day_order','t_days_order','add_desktop_time','is_match_self','match_self_click','match_user_id','media_source','adid','creativeid','marketing_project_id','marketing_promotion_id','match_type','is_report_pay','report_pay_reason','report_pay_time','cz'],
					custom_checkbox: true,
					type:"aa"
				},
			],
			
			tgptSelect: {}, // 推广平台/媒体平台下拉
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth - 60 // 筛选条件大盒子的宽度
		
		function jsTable(){
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				nn = nn + res.width
			})
			that.table_scroll_width = nn + 30
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
		}
		
		// 有自定义列缓存
		if(localStorage.getItem("table_custtom_cd")){
			try{
				let s_title = JSON.parse(localStorage.getItem("table_custtom_cd"))
				that.rableTitle.forEach(res=>{
					s_title.forEach(re_z=>{
						if(res.type == re_z.type){
							res.show_control = re_z.show_control
						}
					})
				})
				// 重新计算表格宽度
				that.computeTableWidth()
				
				// 同时计算一下自定义弹窗里的表格项是否为全选状态
				let i = 0
				that.rableTitle.forEach(res=>{
					if(!res.show_control){ // 如果有未选的，则取消全选状态
						i++
					}
				})
				if(i > 0){
					that.customCheckboxData[0].custom_checkbox = false
				}
			}catch(e){
				jsTable()
			}
		}
		else { // 没自定义列缓存
			console.log("没自定义列缓存");
			jsTable()
		}
		
		// 修改母页面的tab选中状态
		that.$nextTick(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		})
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		// 获取当前日期
		that.endTime = this.$getThisDay()
		// 默认获取1天的日期范围。然后因为非管理员只能看今天和昨天的数据，所以这里的开始时间要这么配
		that.startTime = this.$getThisDay()
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		// 推广平台/媒体平台下拉
		qkChannelMedia().then(res=>{
			console.log("推广平台/媒体平台下拉",res);
			that.tgptSelect = res.data.data.list
		})
		
		// 搜索
		that.searchButton()

	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			// 只能看今天和昨天的日期
			return current && current > moment().endOf('day') || current < moment().subtract(2,"days")
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		onChangeDateC(value, dateString){
			console.log('Selected Time: ', value);
			console.log('Formatted Selected Time: ', dateString);
			this.regStartDate = dateString[0]
			this.regEndDate = dateString[1]
		},
		onDateC_ok(value){
			// console.log('onOk: ', value);
		},
		
		handleChangeD(e){ // 是否回传
			console.log(e);
			this.r_is_report_pay = e
		},
		handleChangeE(e){ // 是否为注册当天订单
			console.log(e);
			this.r_is_reg_day_order = e
		},
		handleChangeF(e){ // 是否匹配到计划
			console.log(e);
			this.r_is_match_ad = e
		},
		handleChangeG(e){ // 是否首充
			console.log(e);
			this.r_is_first_pay = e
		},
		handleChangeH(e){ // 落地页用户类型
			// 不让点击生效，所以这里注释
			// this.h_report_id_type = e
		},
		handleChangeI(e){ // 是否加桌 
			this.r_is_add_desktop = e
		},
		handleChangeTGPT(e){ // 推广平台
			this.r_channel_id = e
		},
		
		// 搜索
		searchButton(type,type_req){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			let r_data = {
				// export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				
				qk_name: that.r_qk_name,
				is_report_pay: that.r_is_report_pay, // 是否回传
				is_reg_day_order: that.r_is_reg_day_order, // 是否为注册当天订单
				is_match_ad: that.r_is_match_ad, // 是否匹配到计划
				is_first_pay: that.r_is_first_pay, // 是否首充
				is_add_desktop: that.r_is_add_desktop, // 是否加桌 0为否。1为是
				
				marketing_project_id: that.r_marketing_project_id, // 项目ID
				marketing_promotion_id: that.r_marketing_promotion_id, // 广告ID
				
				channel_id: that.r_channel_id, // 推广平台
			}
			if(that.r_order_trade_no){ r_data.order_trade_no = that.r_order_trade_no } // 订单ID
			if(that.r_device_id){ r_data.device_id = that.r_device_id } // 用户Device_id
			if(that.r_plan_id){ r_data.plan_id = that.r_plan_id } // 计划ID
			if(that.r_push_link_id){ r_data.push_link_id = that.r_push_link_id } // 推广链接ID
			
			// 注册时间
			if(that.regStartDate){
				r_data.reg_start_date = that.regStartDate
			}
			if(that.regEndDate){
				r_data.reg_end_date = that.regEndDate
			}
			// 排序字段
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 金额区间
			if(that.r_start_money || that.r_start_money == 0){
				r_data.start_money = that.r_start_money
			}
			if(that.r_end_money || that.r_end_money == 0){
				r_data.end_money = that.r_end_money
			}
			
			if(type_req != "导出"){
			CdOrderList(r_data).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			}
			else if(type_req == '导出'){
				r_data.export = 1
				delete r_data.page
				delete r_data.limit
				CdOrderExport(r_data).then(res=>{
					console.log("导出",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						that.$message.success(res.data.msg || "导出成功");
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		// 导出
		exportButton(){
			this.searchButton('','导出')
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 回传操作
		HcTdTable(e,type){
			console.log(e);
			this.hc_id = e.id
			if(type == 0){ // 手动回传头条
				
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				// if(e.match_click_type === 0){ // 0和3都表示巨量
				// 	this.h_report_id_type = 3
				// }
				// else {
				// 	this.h_report_id_type = e.match_click_type
				// }
				console.log("e.channel_id",e.channel_id);
				if(e.channel_id){
					this.h_report_id_type = e.channel_id.toString() 
				}
				else {
					this.h_report_id_type = "1" // 1表示为巨量，没有值就显示巨量
				}
				
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			CdOrderReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0 || res.data.code === 200 || res.data.code == 8011){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
						return
					}
					
					that.$message.error(res.data.msg || '操作失败');
					
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id){
				that.$message.warning('点击表ID不能为空');
				return
			}
			// else if(!that.h_report_id){
			// 	that.$message.warning('落地页用户ID不能为空');
			// 	return
			// }
			
			that.hc_Zdy_loading = true
			CdOrderCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				// report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
		// 前往自建落地页用户表
		goLPzj(){
			// console.log("自建",this.$router.resolve('/LPzj'));
			
			let uuu = ""
			if(this.h_report_id_type == 1){ // 巨量
				uuu = "/LPjl"
			}
			else if(this.h_report_id_type == 2){ // oppo
				uuu = "/clickOPPO"
			}
			else if(this.h_report_id_type == 3){ // vivo
				uuu = "/clickVIVO"
			}
			else if(this.h_report_id_type == 4){ // 华为
				uuu = "/clickHUAWEI"
			}
			else if(this.h_report_id_type == 5){ // 腾讯
				uuu = "/clickTxADQ"
			}
			else if(this.h_report_id_type == 6){ // 百度
				uuu = "/clickBD"
			}
			else if(this.h_report_id_type == 7){ // 快手
				uuu = "/LPks"
			}
			const { href } = this.$router.resolve(uuu)
			// console.log("href",href);
			window.open(href, '_blank');
		},
		
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			// console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				let sort_type = that.rableTitle[index].type
				if(sort_type == 'register_date'){
					sort_type = 'register_time'
				}
				that.tableThClick(index, th_status, sort_type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			// console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton('button')
		},
		
		onChangeNumberS(e){ // 开始金额
			console.log(e);
			this.r_start_money = e
		},
		onChangeNumberE(e){ // 结束金额
			console.log(e);
			this.r_end_money = e
		},
		
		// 自定义列-表格————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列弹窗确认按钮
		customTd(){
			let s_data = []
			this.rableTitle.forEach(res=>{
				let obj = {
					type: res.type,
					show_control: res.show_control
				}
				s_data.push(obj)
			})
			localStorage.setItem("table_custtom_cd",JSON.stringify(s_data));
			this.custtom_visible = false
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			that.table_scroll_width = nn + 30
			
			let www = that.table_scroll_width
			if(that.table_scroll_width < that.body_width){
				console.log("表格宽度小于body_width");
				www = that.body_width
			}
			// 有tab页的才需要这个---
			this.$nextTick(()=>{
				that.$bus.$emit("stickyData", www);
			})
		},
	},
	filters: {
		matchTypeFilter(value){ // 匹配指标。现已改为直接用后端返回的
			let mmm = ""
			if(value == 0){
				mmm = "未匹配"
			}
			else if(value == 1){
				mmm = "系统匹配"
			}
			else if(value == 2){
				mmm = "人工匹配"
			}
			else if(value == 3){
				mmm = "系统匹配：IP匹配"
			}
			else if(value == 4){
				mmm = "系统匹配：IP所在地匹配"
			}
			else if(value == 5){
				mmm = "系统匹配：设备ID匹配"
			}
			else if(value == 6){
				mmm = "用户注册表匹配"
			}
			return mmm
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>